<div class="modal" [class.is-active]="showModal">
    <!-- Omit background until we replace or get rid of the Semantic sidebar; causes this to render improperly -->
    <!-- <div class="modal-background" (click)="handleHideModal()"></div> -->
    <div class="modal-content" [class.wide]="isWide">
        <!-- Any other Bulma elements you want -->
        <ng-content></ng-content>
        <button class="modal-close is-black" aria-label="close" (click)="handleHideModal()">X</button>
    </div>
</div>
